module.exports = __webpack_public_path__ + "static/img/blog-01.9d7a3df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/blog-01.jpg
// module id = 1beD
// module chunks = 7